var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGovernment = function SvgGovernment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "government_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#government_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.008 4.866 5.33 8.105v1.731h13.342V8.105l-6.663-3.239Zm-.013 3.574a.825.825 0 1 0 0-1.65.825.825 0 0 0 0 1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.426 16.628H18.54v1.784H5.426v-1.784ZM6.329 15.41v.593H8.75v-.593h-.37v-4.342h.37v-.592H6.33v.592h.37v4.342h-.37ZM9.37 16.003v-.593h.37v-4.342h-.37v-.592h2.421v.592h-.37v4.342h.37v.593H9.37ZM12.41 15.41v.593h2.422v-.593h-.37v-4.342h.37v-.592H12.41v.592h.371v4.342h-.37ZM15.451 16.003v-.593h.371v-4.342h-.37v-.592h2.422v.592h-.37v4.342h.37v.593h-2.423Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "government_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgGovernment as ReactComponent };